/* DSL Mobile-nav A/B — variant A: standaard hamburger, B: bottom-nav bar */
(function(){
  if (window.matchMedia("(min-width: 750px)").matches) return;
  if (!window.DSL_AB) return;
  var v = window.DSL_AB.getVariant("mobile_nav_v1", ["A","B"]);
  if (v !== "B") return;
  var bar = document.createElement("nav");
  bar.className = "dsl-bottom-nav";
  bar.setAttribute("aria-label", "Mobiele navigatie");
  bar.innerHTML = "<a href=\"/\" aria-label=\"Home\">🏠</a><a href=\"/collections/all\" aria-label=\"Shop\">🛍️</a><a href=\"/search\" aria-label=\"Zoeken\">🔍</a><a href=\"/account\" aria-label=\"Account\">👤</a><a href=\"/cart\" data-cart-drawer-trigger aria-label=\"Cart\">🛒</a>";
  document.body.appendChild(bar);
  document.body.classList.add("dsl-has-bottom-nav");
})();